import type {
  BookingMessageTemplatesListApiData,
  BookingMessageTemplatesListApiResponses,
  BookingSmsListApiData,
  BookingSmsListApiResponses,
  BookingSmsRetryFailedApiData,
  BookingSmsRetryFailedApiResponses,
  BookingSmsesBulkSendApiData,
  BookingSmsesBulkSendApiResponses,
  BookingSmsesBulkSendPreviewApiData,
  BookingSmsesBulkSendPreviewApiResponses,
  SendCustomBookingSmsCreateApiData,
  SendCustomBookingSmsCreateApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const bookingSmsUrls = {
  getBookingMessageTemplates: dataEndpoint<BookingMessageTemplatesListApiData, BookingMessageTemplatesListApiResponses>(
    {
      getUrl: () => apiUrl('booking-message-templates/')
    }
  ),
  getBookingSMSList: dataEndpoint<BookingSmsListApiData, BookingSmsListApiResponses>({
    getUrl: ({ bookingId, ...queryParams }) => apiUrl(`bookings/${bookingId}/sms/`, queryParams)
  }),
  postBookingSMS: responseEndpoint<SendCustomBookingSmsCreateApiData, SendCustomBookingSmsCreateApiResponses>({
    getUrl: () => apiUrl('booking-sms/'),
    getBody: (data) => data
  }),
  postBulkBookingSMS: responseEndpoint<BookingSmsesBulkSendApiData, BookingSmsesBulkSendApiResponses>({
    getUrl: () => apiUrl('booking-sms/bulk-send/'),
    getBody: (data) => data
  }),
  postBulkBookingSMSPreview: responseEndpoint<
    BookingSmsesBulkSendPreviewApiData,
    BookingSmsesBulkSendPreviewApiResponses
  >({
    getUrl: () => apiUrl('booking-sms/bulk-send/preview/'),
    getBody: (data) => data
  }),
  postBookingSMSResend: responseEndpoint<BookingSmsRetryFailedApiData, BookingSmsRetryFailedApiResponses>({
    getUrl: ({ pk }) => apiUrl(`booking-sms/${pk}/retry-failed-sms/`)
  })
};
